import { types } from 'mobx-state-tree';
import moment from 'moment';
import config from '../config';
import { removeItem } from '../lib/localstorage';
import { demoPages } from '../menu';
import AuthService from '../services/AuthService';

export const User = types
	.model('User', {
		id : types.maybe(types.integer),
		type : types.maybe(types.string),
		userId : types.maybe(types.string),
		name : types.maybe(types.string),
		email : types.maybe(types.string),
		gender : types.maybe(types.string),
		birthYear: types.maybe(types.integer),
		industryId: types.maybe(types.integer),
		jobGroupId: types.maybe(types.integer),
		agency : types.maybe(types.string),
		rank : types.maybe(types.string),
		profile : types.maybe(types.string),
		createdAt : types.maybe(types.string),
		updatedAt : types.maybe(types.string),
		status: types.maybe(types.string),
		isAdmin: types.maybe(types.boolean),
	})
	.views((self) => ({
		get me() {
			return { 
				...self, 
			};
		},
		get getid() {
			return self.userId;
		},
	}))
	.actions((self) => ({
		async authMe() {
			try{
				const response = await AuthService.me();
				if (response && response.data) {
					self.setData(response.data);
				} else {
					self.logout();							
					if(window.location.pathname !== '/' + demoPages.login.path) {
						window.location.href = '/' + demoPages.login.path;
					}
				}
			} catch (err) {
				self.logout();
				if(window.location.pathname !== '/' + demoPages.login.path) {
					window.location.href = '/' + demoPages.login.path;
				}
			}
		},
		setid(id){
			self.userId = id;
		},
		setProfileImage(fileName){
			self.profile = fileName;
		},
		async setData(data) {
			self.id = data?.id || self.id;
			self.type = data?.type || self.type;
			self.userId = data?.userId || self.userId;
			self.name = data?.name || self.name;
			self.email = data?.email || self.email;
			self.gender = data?.gender || self.gender;
			self.birthYear = data?.birthYear || self.birthYear;
			self.industryId = data?.industryId || self.industryId;
			self.jobGroupId = data?.jobGroupId || self.jobGroupId;
			self.agency = data?.agency || self.agency;
			self.rank = data?.rank || self.rank;
			self.profile = data?.profile || self.profile;
			self.status = data?.status || self.status;
			self.createdAt = moment(data?.createdAt || '').format('YYYY-MM-DD HH:mm:ss');
			self.updatedAt = moment(data?.updatedAt || '').format('YYYY-MM-DD HH:mm:ss');
			self.isAdmin = data?.email === '8ismlab@naver.com' || data?.email === 'jacos15@nate.com' ? true : false
		},
		async logout() {	
			self.id = 0;		
			self.type = '';
			self.userId = '';
			self.name = '';
			self.email = '';
			self.gender = '';
			self.birthYear = 0;
			self.industryId = 0;
			self.jobGroupId = 0;
			self.agency = '';
			self.rank = '';
			self.profile = '';
			self.status = '';
			self.createdAt = '';
			self.updatedAt = '';
			self.isAdmin = false;
		},
	}));

export default User;
